import bytesToUuid from './bytesToUuid';

declare const unescape: (v: string) => string;

function uuidToBytes(uuid: string) {
	// Note: We assume we're being passed a valid uuid string
	const bytes: number[] = [];
	uuid.replace(/[a-fA-F0-9]{2}/g, (hex: string) => {
		bytes.push(parseInt(hex, 16));
		return hex;
	});

	return bytes;
}

function stringToBytes(str: string) {
	str = unescape(encodeURIComponent(str)); // UTF8 escape
	const bytes = new Array(str.length);
	for (let i = 0; i < str.length; i++) {
		bytes[i] = str.charCodeAt(i);
	}
	return bytes;
}

export type StringOrNumArray = string | number[];
export type HashFunc = (v: string | number[]) => number[];

export interface GenerateUUID {
	(value: StringOrNumArray, namespace: StringOrNumArray): string;
	(value: StringOrNumArray, namespace: StringOrNumArray, buf: Uint8Array): Uint8Array;
	(value: StringOrNumArray, namespace: StringOrNumArray, buf: Uint8Array, offset: number): Uint8Array;
	(value: StringOrNumArray, namespace: StringOrNumArray, buf?: Uint8Array, offset?: number): Uint8Array | string;
	uuidname?: string;
	DNS?: string;
	URL?: string;
}

export function v35(name: string, version: number, hashfunc: HashFunc): GenerateUUID {
	// tslint:disable-next-line:prefer-const
	const generateUUID = function generateUUID(
		value: StringOrNumArray,
		namespace: StringOrNumArray,
		buf?: Uint8Array,
		offset: number = 0
	): Uint8Array | string {
		if (typeof value === 'string') {
			value = stringToBytes(value);
		}
		if (typeof namespace === 'string') {
			namespace = uuidToBytes(namespace);
		}

		if (!Array.isArray(value)) {
			throw TypeError('value must be an array of bytes');
		}
		if (!Array.isArray(namespace) || namespace.length !== 16) {
			throw TypeError('namespace must be uuid string or an array of 16 byte values');
		}

		// Per 4.3
		const bytes = hashfunc(namespace.concat(value));
		bytes[6] = (bytes[6] & 0x0f) | version;
		bytes[8] = (bytes[8] & 0x3f) | 0x80;

		if (buf !== undefined) {
			for (let idx = 0; idx < 16; ++idx) {
				buf[offset + idx] = bytes[idx];
			}
		}

		return buf !== undefined ? buf : bytesToUuid(new Uint8Array(bytes));
	} as GenerateUUID;

	generateUUID.uuidname = name;

	// Pre-defined namespaces, per Appendix C
	generateUUID.DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
	generateUUID.URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';

	return generateUUID;
}

export default v35;
